// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoReportModal-cls1_sZP","cls2":"VideoReportModal-cls2_a8I VideoReportModal-cls1_sZP"};